/**
 * L2-P1: moved to @miq/shared-models (models/strings.constants.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
export { PRIORITY_FIELD, EMPTY_STRING, DASH, ADD, ALL, TWO_DECIMALS_FORMAT, CIQ_FETCH_TIM_DEFAULTS_QUERY, SEARCH_V2_API, SEARCH_V2_FEATURE_DATA, HIDE_V2_FEATURE_DATA, MIQ_2_0_FEATURE_NAME, MIQ_2_0_FEATURE_DATA, MIQ_2_0_NAVBAR_V2_FEATURE_ID, MIQ_2_0_FILTER_SET_MIQ2_FEATURE_ID, MIQ_2_0_DIGITAL_ASSISTANT_FEATURE_ID, ThemeLabelFallback } from '@miq/shared-models';
